<template>
    <section class="dead-horses-page">
        <h1 id="dead-horses" class="print-title">Horses reported to have died</h1>
        <h3 id="years" class="print-title black-title"> {{ yearsRange }} </h3>
    </section>

    <DataTable class="table-horses-universal" :value="deadHorses" :rowClass="rowClass">
        <Column bodyClass="horse-name" field="name" header="Name"></Column>
        <Column field="regNr" header="Reg.Nr ">
            <template #body="slotProps">
                {{ addBrackets(slotProps.data.regNr) }}
            </template>
        </Column>
        <Column field="dateOfDeath" header="Date of death if known"></Column>
    </DataTable>

</template>

<script>
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import {yearFromToMixin} from "@/views/readonly/studbook/util/yearFromToMixin";
import {addBracketsMixin} from "@/views/readonly/studbook/util/addBracketsMixin";

export default {
    name: "DeadHorsesPage",
    components: { DataTable, Column },
    mixins: [yearFromToMixin, addBracketsMixin],
    props: {
        deadHorses: Array,
    },
    methods: {
        rowClass() {
            return {
                "table-row": true,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../mixins";
section.dead-horses-page {
    margin-top: 20% !important;
}
.table-horses-universal {
    tbody tr {
        break-inside: avoid;
        break-after: auto;
        break-before: auto;
    }
    .p-datatable-wrapper {
        .p-datatable-tbody,
        .p-datatable-thead {
            tr {
                @include grid-container(5fr 2fr 3fr, 0);
            }
        }
    }
}
</style>
